module.exports = "<p>common works!</p>\r\n"